module.exports = __webpack_public_path__ + "static/media/fmi_logo.89d6e2b3.png";